import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { id: "modal-container-element" }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { class: "search-container" }
const _hoisted_4 = ["value"]
const _hoisted_5 = ["rows", "total-items", "current-page", "loading"]

import { EPINIO_TYPES } from '../types';
import { useStore } from 'vuex';
import { computed, ref, watch } from 'vue';
import Masthead from '@shell/components/ResourceList/Masthead';
import { debounce } from 'lodash';
import { makeActionMenu } from '../utils/table-formatters';
import GitConfigModal from '../components/gitconfigs/GitConfigModal.vue';
import GitConfigDeleteModal from '../components/gitconfigs/GitConfigDeleteModal.vue';
import { ListResourceRequestParams, ResourceQueryOptions, ResourceTableRow } from '../models/resource/ui-types';
import { useGitConfigs } from '../queries/useGitConfigQueries';
import { GitConfig } from '../models/gitconfig/ui-types';
import { useUser } from '../queries/useUserQueries';
import Banner from '@components/Banner/Banner.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'gitconfigs',
  props: {
    schema: {}
  },
  setup(__props: any) {

 // Keep for compatibility

const store = useStore();

const gitConfigModal = ref<InstanceType<typeof GitConfigModal> | null>(null);
const gitConfigDeleteModal = ref<InstanceType<typeof GitConfigDeleteModal> | null>(null);

const resource: string = EPINIO_TYPES.GIT_CONFIG;

const { data: user, isError: isErrorUser, error: userError } = useUser(store);

const requestParams = ref<ListResourceRequestParams>({
  page: 1,
  pageSize: 10,
  search: '',
});

const requestOptions = ref<ResourceQueryOptions>({
  enabled: true,
  polling: true,
  isTablePagination: true,
});

const searchQuery = ref<string>('');

watch(searchQuery, (newQuery) => {
  onSearch(newQuery);
});

const onSearch = debounce(async (query: string) => {
  requestParams.value.page = 1;
  requestParams.value.search = query;
}, 500);

const {data: gitConfigs, isLoading: isLoadingGitConfigs, isError: isErrorGitConfigs, error: gitConfigsError} = useGitConfigs(store, requestParams, requestOptions);

const canEdit = computed(() => {
  return user.value?.permissions?.gitconfig_write || user.value?.permissions?.gitconfig;  
});
const canDelete = canEdit;
const canCreate = canEdit;

const openDeleteModal = (gitConfig: GitConfig) => {
  gitConfigDeleteModal.value?.openDelete(gitConfig);
};


const displayRows = computed(() => {
  if (!gitConfigs.value) {
    return [];
  }

  const rows: ResourceTableRow<GitConfig>[] = (gitConfigs.value.items ?? []).map((gc) => ({
    ...gc,
    id: gc.meta.name,
    availableActions: [{
      label: 'Delete',
      action: () => openDeleteModal(gc),
      enabled: canDelete.value,
      visible: canDelete.value,
      danger: true,
    }],
    canDelete: canDelete.value,
  }));
  return rows;
});

const columns = [
  {
    field: 'meta.name',
    label: 'Name'
  },
  {
    field: 'provider',
    label: 'Provider',
    formatter: 'gitProviders'
  },
  {
    field: 'url',
    label: 'URL'
  },
  {
    field:     'meta.createdAt',
    label:     'Age',
    formatter: 'age'
  }
];

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_unref(Masthead), {
        schema: _ctx.schema,
        resource: _unref(resource)
      }, {
        createButton: _withCtx(() => [
          (_unref(canCreate))
            ? (_openBlock(), _createElementBlock("trailhand-button", {
                key: 0,
                variant: "primary",
                size: "large",
                onButtonClick: _cache[0] || (_cache[0] = ($event: any) => (gitConfigModal.value?.openCreate()))
              }, _toDisplayString(_ctx.t('generic.create')), 33))
            : (_openBlock(), _createElementBlock("div", _hoisted_2))
        ]),
        _: 1
      }, 8, ["schema", "resource"]),
      _cache[3] || (_cache[3] = _createTextVNode()),
      (_unref(isErrorUser))
        ? (_openBlock(), _createBlock(Banner, {
            key: 0,
            color: "error",
            label: _unref(userError)?.message || _ctx.t('epinio.user.errors.fetch')
          }, null, 8, ["label"]))
        : _createCommentVNode("", true),
      _cache[4] || (_cache[4] = _createTextVNode()),
      (_unref(isErrorGitConfigs))
        ? (_openBlock(), _createBlock(Banner, {
            key: 1,
            color: "error",
            label: _unref(gitConfigsError)?.message || _ctx.t('epinio.gitconfigs.errors.fetch')
          }, null, 8, ["label"]))
        : _createCommentVNode("", true),
      _cache[5] || (_cache[5] = _createTextVNode()),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("trailhand-text-input", {
          value: searchQuery.value,
          placeholder: "Search...",
          onTextInputChange: _cache[1] || (_cache[1] = (e) => searchQuery.value = e.detail.value)
        }, null, 40, _hoisted_4)
      ]),
      _cache[6] || (_cache[6] = _createTextVNode()),
      _createElementVNode("trailhand-table", {
        ref: (el) => { if (el) el.renderActions = _unref(makeActionMenu); },
        rows: displayRows.value,
        columns: columns,
        "server-side": true,
        searchable: false,
        "total-items": _unref(gitConfigs)?.totalItems ?? 0,
        "current-page": requestParams.value.page,
        loading: _unref(isLoadingGitConfigs),
        "key-field": "id",
        onPageChange: _cache[2] || (_cache[2] = (e) => { requestParams.value.page = e.detail.page; })
      }, null, 40, _hoisted_5)
    ]),
    _cache[7] || (_cache[7] = _createTextVNode()),
    _createVNode(GitConfigModal, {
      ref_key: "gitConfigModal",
      ref: gitConfigModal
    }, null, 512),
    _cache[8] || (_cache[8] = _createTextVNode()),
    _createVNode(GitConfigDeleteModal, {
      ref_key: "gitConfigDeleteModal",
      ref: gitConfigDeleteModal
    }, null, 512)
  ], 64))
}
}

})